<template>
    <div>
        <MainTheme>
            <!-- ./components/MainTheme.vue 를 가져옵니다.-->
        </MainTheme>
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">                 
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-12">
                                <span class="display-1 text-shadow-white text-size-head" style="color:red">태안</span>
                                <span class="display-1 text-shadow-white text-size-head" style="color:blue">
                                    선상낚시
                                </span>
                                <br>
                                <span class="display-1 text-shadow-white text-size-head" style="color:black">
                                    태안현아호 &#127754;
                                </span>
                                
                                <p class="lead text-white">
                                    <b>
                                        <span>생동감이 넘치는 선상낚시&#128011;&#127907;</span>
                                        <br>
                                        <span class="font-weight-bold" style="color:black">'태안현아호'</span>
                                    </b>
                                </p>
                                <div class="btn-wrapper">
                                    <base-button tag="a"
                                                href="http://okfishing.sunsang24.com/ship/schedule_fleet"
                                                target="_blank"
                                                class="mb-3 mb-sm-0"
                                                type="danger">
                                                🚢 출조일정/예약하기
                                    </base-button>
                                    <base-button tag="a"
                                                href="tel:010-6420-3139"
                                                class="mb-3 mb-sm-0"                                                
                                                icon="fa fa-phone"
                                                style="background-color: #2DB400; border: 0px;"
                                                >
                                        전화문의
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
        <section class="section section-lg pt-lg-0 mt--200 p-2">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12">
                        <div class="row row-grid">
                            <div class="col-lg-4">
                                <card class="border-0 bg-darkblue" style="height: 168px;" hover shadow body-classes="py-5">
                                    <div class="card-top">
                                        <icon style="color:white;background-color: #2DB400;" type="primary" rounded >
                                            <i class="fa fa-phone" style="font-size: xx-large;"></i>
                                        </icon>
                                        <div class="text-size-xlarge pl-20">
                                            <b>
                                                <span style="color:white">010-6420-3139</span>
                                            </b>
                                        </div>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <card class="border-0 bg-darkblue" style="height: 168px; cursor: pointer;" hover shadow body-classes="py-5" data-clipboard-text="477141-52-034771" onclick="toggleAlert();">
                                    <div class="card-top">
                                        <icon style="color:white; background-color: goldenrod;" rounded >
                                            <i class="fa fa-university" style="font-size: x-large;"></i>
                                        </icon>
                                        <div class="text-size-large pl-20">
                                            <b>
                                                <span style="color:white">농협 예금주 : 백옥현</span><br>
                                                <span style="color:white">477141-52-034771</span><br>
                                            </b>
                                        </div>
                                    </div>
                                </card>
                            </div>
                            <div class="col-lg-4">
                                <a href="/location">
                                    <card class="border-0 bg-darkblue" style="height: 168px;" hover shadow body-classes="py-5">
                                        <div class="card-top">
                                            <icon style="color:white; background-color: orangered;" rounded >
                                                <i class="fa fa-bandcamp" style="font-size: xx-large;"></i>
                                            </icon>
                                            <div class="text-size-large pl-20">
                                                <div>
                                                    <b>
                                                        <span style="color:gold">태안현아호 오시는 길</span>
                                                        <br>
                                                        <span style="color:white"></span>
                                                    </b>
                                                </div>
                                            </div>
                                        </div>
                                    </card>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section">
            <div class="container">
                <div class="row row-grid align-items-center">
                    <div class="col-md-3 col-6 four-card">
                        <a href="https://www.badatime.com/132.html" target="_blank">
                            <div class="card bg-default shadow border-0">
                                <img v-lazy="'img/theme/badatime.png'" class="card-img-top">
                                <blockquote class="card-blockquote" style="padding: 1rem;">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                        class="svg-bg">
                                        <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                        <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                    </svg>
                                    <p class="lead text-italic text-white">바다타임</p>
                                </blockquote>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-3 col-6 four-card">
                        <a href="/weatherInfo" target="_blank">
                            <div class="card bg-default shadow border-0">
                                <img v-lazy="'img/theme/imoc.png'" class="card-img-top">
                                <blockquote class="card-blockquote" style="padding: 1rem;">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                        class="svg-bg">
                                        <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                        <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                    </svg>
                                    <p class="lead text-italic text-white">IMOC 파도</p>
                                </blockquote>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-3 col-6 four-card">
                        <a href="https://www.windguru.cz/314361" target="_blank">
                            <div class="card bg-default shadow border-0">
                                <img v-lazy="'img/theme/windy.png'" class="card-img-top">
                                <blockquote class="card-blockquote" style="padding: 1rem;">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                        class="svg-bg">
                                        <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                        <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                    </svg>
                                    <p class="lead text-italic text-white">Windy</p>
                                </blockquote>
                            </div>
                        </a>
                    </div>
                    <div class="col-md-3 col-6 four-card">
                        <a href="https://www.surfline.com/surf-charts/@31.75,135,4.5z?type=wave-height" target="_blank">
                            <div class="card bg-default shadow border-0">
                                <img v-lazy="'img/theme/windfinder.png'" class="card-img-top">
                                <blockquote class="card-blockquote" style="padding: 1rem;">
                                    <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 583 95"
                                        class="svg-bg">
                                        <polygon points="0,52 583,95 0,95" class="fill-default"></polygon>
                                        <polygon points="0,42 583,95 683,0 0,95" opacity=".2" class="fill-default"></polygon>
                                    </svg>
                                    <p class="lead text-italic text-white">Windfinder</p>
                                </blockquote>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <section class="section bg-secondary">
            <div class="container">
                <h2 class="display-3" style="text-align: center;">🚢출조일정🌊</h2>
                <BookingHead></BookingHead>
            </div>
        </section>
        <section class="section section-lg">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 mb-5 mb-md-0 text-center">
                        <div class="card card-lift--hover shadow border-0">
                            <router-link to="/baitingInfo" title="조황정보">
                                <img v-lazy="'img/theme/gallery-1.png'" class="card-img">
                            </router-link>
                        </div>
                        <p class="lead">
                            조황정보
                        </p>
                    </div>
                    <div class="col-md-6 mb-5 mb-lg-0 text-center">
                        <div class="card card-lift--hover shadow border-0">
                            <router-link to="location" title="오시는 길">
                                <img v-lazy="'img/theme/gallery-2.png'" class="card-img">
                            </router-link>
                        </div>
                        <p class="lead">
                            오시는 길
                        </p>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-3 bg-gradient-default shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="container pt-lg pb-150">
                <div class="row text-center justify-content-center">
                    <div class="col-lg-10">
                        <h2 class="display-3 text-white">연락처 안내</h2>
                        <p class="lead text-white">생생한 손맛이 기억하는 태안현아호</p>
                    </div>
                </div>
                <div class="row row-grid mt-5">
                    <div class="col-lg-4">
                        <icon name="fa fa-phone" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3"><b>선박문의 </b></h5>
                        <h5 class="text-white">태안현아호</h5>
                        <h5 class="text-white">010-6420-3139</h5>
                    </div>
                    <div class="col-lg-4">
                        <icon name="fa fa-university" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3"><b>태안현아호 입금안내</b></h5>
                        <div class="text-white">농협 예금주 : 백옥현</div>
                        <div class="text-white">477141-52-034771</div><br>
                        <div style="cursor: pointer;" class="btn btn-secondary" data-clipboard-text="477141-52-034771" onclick="toggleAlert();">계좌번호 복사</div>
                    </div>
                    <div class="col-lg-4">
                        <icon name="fa fa-map-signs" size="lg" gradient="white" shadow round color="primary"></icon>
                        <h5 class="text-white mt-3">출조시간</h5>
                        <h5 class="text-white">04:00 ~ 15:00</h5>
                    </div>
                </div>
            </div>
        </section>
        <section class="section pt-0 pb-0">
            <div class="container">
                <div class="row row-grid align-items-center my-md">
                    <div class="col-lg-6">
                        <h3 class="text-primary font-weight-light mb-2">잊을 수 없는 손맛</h3>
                        <h4 class="mb-0 font-weight-light">짜릿하고 풍성한 조황!
                            <br>지금 태안현아호에 탑승하세요.
                        </h4>
                    </div>
                    <div class="col-lg-6 text-lg-center btn-wrapper">
                        <base-button tag="a"
                            href="http://okfishing.sunsang24.com/ship/schedule_fleet"
                            class="mb-3 mb-sm-0"
                            target="_blank"
                            type="danger">
                            🚢 출조일정/예약하기
                        </base-button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import MainTheme from "./components/MainTheme";
import BookingHead from './components/BookingHead.vue';

export default {
  name: "home",
  components: {
    MainTheme,
    BookingHead
  }
};
</script>
<style>
.text-shadow-white {
    text-shadow: -1px 0px white, 0px 1px white, 1px 0px white, 0px -1px white;
}

@media all and (min-width: 320px) { 
    .text-size-head{
        font-style: italic;
    }
    .section-shaped .shape.shape-skew + .shape-container {
        padding-top: 10rem !important;
        padding-bottom: 0rem !important;
    }
}

@media all and (min-width: 740px) { 
    .text-size-head{
        font-size: 7rem !important;
        font-style: italic;    
    }

    .section-shaped .shape.shape-skew + .shape-container {
        padding-top: 18rem !important;
        padding-bottom: 19rem !important;
    }
}

.text-cursive{
    font-family: cursive, sans-serif;
}

.text-size-large{
    font-size: large;
}

.text-size-xlarge{
    font-size: x-large;
}

.card-top{
    display: flex; 
    align-items: center;
    min-height: 72px;
}

.pl-20{
    padding-left: 20px;
}

.bg-darkblue {
    background-color:darkblue !important;
}

.four-card{
    max-width: 12rem;
}
</style>